import axiosInstance from "./axiosInstance";

/**
 * Cliente base para todas las llamadas a la API
 * Proporciona métodos genéricos para operaciones HTTP
 */
class ApiClient {
  /**
   * Realiza una petición GET
   * @param {string} url - Endpoint de la API
   * @param {object} config - Configuración adicional de Axios
   * @returns {Promise} Respuesta de la API
   */
  async get(url, config = {}) {
    try {
      const response = await axiosInstance.get(url, config);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Realiza una petición POST
   * @param {string} url - Endpoint de la API
   * @param {object} data - Datos a enviar
   * @param {object} config - Configuración adicional de Axios
   * @returns {Promise} Respuesta de la API
   */
  async post(url, data = {}, config = {}) {
    try {
      const response = await axiosInstance.post(url, data, config);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Realiza una petición PUT
   * @param {string} url - Endpoint de la API
   * @param {object} data - Datos a enviar
   * @param {object} config - Configuración adicional de Axios
   * @returns {Promise} Respuesta de la API
   */
  async put(url, data = {}, config = {}) {
    try {
      const response = await axiosInstance.put(url, data, config);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Realiza una petición DELETE
   * @param {string} url - Endpoint de la API
   * @param {object} config - Configuración adicional de Axios
   * @returns {Promise} Respuesta de la API
   */
  async delete(url, config = {}) {
    try {
      const response = await axiosInstance.delete(url, config);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  /**
   * Maneja errores de forma consistente
   * @param {Error} error - Error capturado
   * @returns {Error} Error formateado
   */
  handleError(error) {
    if (error.response) {
      // El servidor respondió con un código de estado fuera del rango 2xx
      return {
        message: error.response.data?.message || "Error en la petición",
        status: error.response.status,
        data: error.response.data,
      };
    } else if (error.request) {
      // La petición se hizo pero no se recibió respuesta
      return {
        message: "No se recibió respuesta del servidor",
        status: 0,
      };
    } else {
      // Algo sucedió al configurar la petición
      return {
        message: error.message || "Error desconocido",
        status: 0,
      };
    }
  }
}

const apiClient = new ApiClient();

export default apiClient;
